<template>
  <div class="gift-wrap">
    <app-header />
    <div class="gift-wrap-con">
      <div class="mod1">
        <h2>活动期间购买大礼包（价值60361元）即可获得以下权限：</h2>
        <p>1、PC端：《大智慧策略投资终端》1年，价值38000元；</p>
        <p>2、APP端：18款功能产品1年，价值22361元。<span @click="backTo">详见列表</span></p>
      </div>
      <div class="mod2">
        <h2 class="title">PC助力热门功能</h2>
        <div class="list">
          <div class="item">
            <i></i>
            <span>热点狙击</span>
            <p>紧抓题材时间，捕捉最具影响市场趋势动向。</p>
          </div>
          <div class="item">
            <i></i>
            <span>热点轮动</span>
            <p>关联概念龙头，深度剖析事件把握投资亮点。</p>
          </div>
          <div class="item">
            <i></i>
            <span>AI资金线</span>
            <p>热钱去哪我去哪，跟随大资金的步伐。</p>
          </div>
        </div>
      </div>
      <div class="mod2">
        <h2 class="title title2">APP助力热门功能</h2>
        <div class="list list2">
          <div class="item">
            <i></i>
            <span>题材王</span>
            <p>狙击一线热点 ，只为核心题材。</p>
          </div>
          <div class="item">
            <i></i>
            <span>优选大师</span>
            <p>盘前、盘中、盘后全面刨铣市场逻辑。</p>
          </div>
          <div class="item">
            <i></i>
            <span>白马智投</span>
            <p>挖掘价值洼地中的绩优股。</p>
          </div>
        </div>
      </div>
      <div class="mod3" ref="mod3">
        <h2 class="title title3"></h2>
        <ul class="list">
          <li v-for="(item, index) in productList" :key="index">
            <div>
              <span>{{item.name}}</span>
              <em>{{item.money}}</em>
            </div>
          </li>
        </ul>
        <div class="price-box">
          <p>现优惠价只要：</p>
          <span>9800</span>
          <strong>元/年</strong>
        </div>
      </div>
    </div>
    <router-link :to="buyUrl" class="btn-buy" target="_blank"></router-link>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
export default {
  name: 'GiftPages',
   components: {
    AppHeader
  },
  data() {
    return {
      token: '',
      buyUrl : '/gateway?method=order.confirm.3028',
      productList: [
        {
          name: '产品名称',
          money: '原价（元/年）'
        },
        {
          name: '云梯通道',
          money: '339'
        },
        {
          name: '双突战法',
          money: '88'
        },
        {
          name: '神奇D信号',
          money: '88'
        },
        {
          name: '九转交易',
          money: '1099'
        },
        {
          name: '主力筹码追踪',
          money: '888'
        },
        {
          name: '优选大师',
          money: '9800'
        },
        {
          name: '波段王',
          money: '799'
        },
        {
          name: '白马智投',
          money: '1699'
        },
        {
          name: '港股level-2',
          money: '68'
        },
        {
          name: '追击反转',
          money: '618'
        },
        {
          name: '尾盘动能',
          money: '848'
        },
        {
          name: '资金搏击',
          money: '818'
        },
        {
          name: '题材王',
          money: '1598'
        },
        {
          name: '异动查',
          money: '299'
        },
        {
          name: '情绪转点',
          money: '698'
        },
        {
          name: '机构热股',
          money: '1099'
        },
        {
          name: '抢筹先锋',
          money: '898'
        },
        {
          name: '分时顶底',
          money: '898'
        },
         {
          name: '合计：',
          money: '22361'
        }
      ]
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
      this.checkToken();
      this.buyUrl += "&token=" + token;
    }
  },
  methods: {
      checkToken() {
      var params = {
        token: this.token,
        isRecord: 1
      };
      this.$post("/user/checkToken", params).then(response => {

      });
    },
    backTo () {
      let top = this.$refs.mod3.offsetTop
      window.scrollTo(0, top);
    },
  }
}
</script>

<style lang="scss" scoped>
div{
  box-sizing: border-box;
}
.gift-wrap .mod1 p span:after,
.gift-wrap .mod2 .list .item i:after{
  background-image: url(../../assets/images/activity/giftpages08/icon.png);
  background-repeat: no-repeat;
}
.gift-wrap .title{background-image: url(~@/assets/images/activity/giftpages08/title-bg.png);@include wh(403px, 75px); @include center-box-x; top: -9px;text-indent: -9999rem;}
.gift-wrap{
  background: url(../../assets/images/activity/giftpages08/bg1.jpg) no-repeat center 100px,
              url(../../assets/images/activity/giftpages08/bg2.jpg) no-repeat center 1100px,
              url(../../assets/images/activity/giftpages08/bg3.jpg) no-repeat center 2100px,
              url(../../assets/images/activity/giftpages08/bg4.jpg) no-repeat center 3100px #d1f3fa;
  padding-bottom: 50px;
  position: relative;
  padding-bottom: 480px;
  .gift-wrap-con{
   width: 1200px;
   margin: 674px auto 0;
  }
  .mod1{
    background: url(../../assets/images/activity/giftpages08/mod-bg1.png) no-repeat;
    @include wh(1200px, 367px);
    padding: 98px 0 53px 144px;
    position: relative;
    &:before{
      content: '';
      display: block;
      background: url(../../assets/images/activity/giftpages08/price.png) no-repeat;
      @include wh(306px, 198px);
      position: absolute;
      top: -89px;
      right: -57px;
    }
    h2{
      @include fc(36px, #fff);
      margin-bottom: 30px;
    }
    p{
      @include fc(30px, #ffea96);
      +p{
        margin-top: 15px;
      }
      span{
        color: #88e6dd;
        cursor: pointer;
        &:after{
          content: '';
          display: inline-block;
          @include wh(14px, 13px);
          background-position: 0 -785px;
          margin-left: 10px;
        }
      }
    }
  }
  .mod2{
    background: #76def6;
    border-radius: 20px;
    padding: 75px 0 40px;
    margin: 40px 0 60px;
    position: relative;
    box-shadow: 0 10px 10px rgba(#32b0dd, 0.3);
    .title{
      background-position: 0 -206px;
    }
    .title2{
      background-position: 0 -113px;
    }

    .list{
      overflow: hidden;
      padding: 55px 0px 50px;
      margin: 0 30px;
      background: #fff;
      border-radius: 30px;
      .item{
        float: left;
        width: 370px;
        &:nth-child(2){
          margin: 0 14px;
          i{
            &:after{
              background-position: -140px 0;
            }
          }
        }
        &:nth-child(3){
          i{
            &:after{
              background-position: -280px 0px;
            }
          }
        }
        i{
          display: block;
          @include wh(140px, 140px);
          border-radius: 10px;
          position: relative;
          margin: 0 auto 25px;
          &:after{
            content: '';
            display: block;
            @include wh(140px, 140px);
            @include center;
            background-position: 0 0;
          }
        }
        span{
          display: block;
          @include fc(30px, #343434);
          margin-bottom: 10px;
          text-align: center;
        }
        p{
          @include fc(22px, #333333);
          line-height: 30px;
          width: 230px;
          margin: 0 auto;
          text-align: justify;
        }
      }
    }
    .list2{
      .item{
        &:nth-child(1){
          i{
            &:after{
              background-position: 0 -140px;
            }
          }
        }
        &:nth-child(2){
          i{
            &:after{
              background-position: -140px -140px;
            }
          }
        }
        &:nth-child(3){
          i{
            &:after{
              background-position: -280px -140px;
            }
          }
        }
      }
    }
  }
  .mod3{
    padding: 80px 0 40px 40px;
    position: relative;
    background: #76def6;
    border-radius: 20px;
    box-shadow: 0 10px 10px rgba(#32b0dd, 0.3);
    .title3{
      background-position: 0 0;
      width: 603px;
    }
    .list{
      background: #fff;
      width: 545px;
      border-radius: 10px;
      li{
        height: 47px;
        line-height: 47px;
        overflow: hidden;
        @include fc(24px, #f3534c);
        padding: 0 56px;
        >div{
          border-bottom: 1px solid #f3534c;
          height: 47px;
        }
        span{
          float: left;
        }
        em{
          float: right;
        }
        &:nth-child(1){
          background: #fec65b;
          border-radius: 10px 10px 0 0;
          color: #fff;
          >div{
            border-bottom: none;
          }
        }
        &:nth-last-child(2){
          >div{
            border-bottom: none;
          }
        }
        &:last-child{
          background: #fedd9d;
          color: #f2433e;
          border-radius: 0 0 10px 10px;
          >div{
            border-bottom: none;
          }
        }
      }
    }
    .price-box{
      position: absolute;
      top: 120px;
      left: 695px;
      @include fc(60px, #f2433e);
      &:after{
        content: '';
        display: block;
        @include wh(402px, 340px);
        position: absolute;
        left: 0;
        top: 505px;
        background: url(~@/assets/images/activity/giftpages08/goldCoins.png);
      }
      >p {
        margin-left: 15px;
      }
      span{
        @include center-text(410px, 170px);
        font-size: 150px;
        display: block;
        background: #fff;
        border-radius: 20px;
        margin: 25px 0;
        font-weight: bold;
      }
      strong{
        text-align: center;
        font-weight: normal;
        display: block;
      }
    }
  }
  .btn-buy{
    display: block;
    @include wh(1318px, 282px);
    background: url(~@/assets/images/activity/giftpages08/btn-buy.png);
    @include center-box-x;
    bottom: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/GiftPages08.vue